import { useSearchParams } from "react-router-dom";
import { helpDocuments } from "../../../documentation/helpDocuments";
import { usePageState } from "../../context/usePageState";

export interface HelpDocument {
  id: string;
  href: string;
  title: string;
  description: string;
  allowedRoles?: string[];
  imageMap: Record<string, string>;
}

/** The guides the reader may open, and the one `?document=` names, if any. */
export function useHelpDocuments() {
  const { hasAnyRole } = usePageState();
  const [searchParams] = useSearchParams();
  const selectedId = searchParams.get("document");
  // The bundler hands back each .md as a URL, though its typings say a component.
  const documents = (helpDocuments as unknown as HelpDocument[]).filter(
    (document) =>
      !document.allowedRoles || hasAnyRole(document.allowedRoles)
  );

  return {
    documents,
    selected: documents.find((document) => document.id === selectedId),
  };
}

export function helpDocumentUrl(id?: string) {
  return id ? `/help?document=${id}` : "/help";
}
